module.exports = __webpack_public_path__ + "img/vertical_7_6_5010.5783a22b.png";